import { Module } from 'vuex';

import { RootState, TypedDict } from 'frontend/types';
import { ApplicationState, BaseChoice } from 'frontend/types/classrooms';

const choiceKeyByName = (choices: BaseChoice[]): TypedDict<number> => {
  const keyValPairs: TypedDict<number> = {};
  for (const choice of choices) {
    keyValPairs[choice.name] = choice.key;
  }
  return keyValPairs;
};

const educatorApplication: Module<ApplicationState, RootState> = {
  namespaced: true,
  state: {} as ApplicationState,
  getters: {
    programTypeChoices: state => state.program_types.choices,
    referralChoices: state => state.referral_types.choices,
    title1StatusChoices: state => state.school_title_1_status.choices,
    underservedCommunityChoices: state => state.underserved_community.choices,
    hasPendingApplication: state => state.has_pending_application,
    programTypeChoice: state => choiceKeyByName(state.program_types.choices),
    referralChoice: state => choiceKeyByName(state.referral_types.choices),
    underservedCommunityChoice: state => choiceKeyByName(state.underserved_community.choices),
  },
  mutations: {
    setValue(state: ApplicationState, value: ApplicationState): void {
      Object.assign(state, value);
    },
  },
  actions: {},
};

export default educatorApplication;
